import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { Check, X } from 'lucide-react';
export const WhoFor = () => {
  const forWho = ['Empleados que llegan con lo justo a fin de mes y necesitan un ingreso extra urgente.', 'Estudiantes que quieren ganar en dólares sin descuidar sus estudios.', 'Personas que pasan mucho tiempo en redes sociales y quieren profesionalizar ese tiempo.', 'Cualquier argentino harto de la inflación que busque un "Plan B" sólido.'];
  const notForWho = ['Personas que buscan hacerse millonarias de la noche a la mañana sin trabajar.', 'Gente que no está dispuesta a enviar al menos 20-30 mensajes por día.', 'Aquellos que no saben usar Instagram a nivel básico.'];
  return <AnimatedSection className="bg-sepia/20 border-y border-ink/10" data-id="element-181">
      <div className="grid md:grid-cols-2 gap-12 md:gap-20" data-id="element-182">
        {/* Left Column */}
        <div data-id="element-183">
          <h3 className="text-2xl font-serif text-ink mb-8 pb-4 border-b border-ink/20" data-id="element-184">
            Para vos si...
          </h3>
          <ul className="space-y-6" data-id="element-185">
            {forWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-186">
                <div className="mt-1 text-accent flex-shrink-0" data-id="element-187">
                  <Check size={20} strokeWidth={2.5} data-id="element-188" />
                </div>
                <p className="font-sans text-ink/80 leading-relaxed" data-id="element-189">{item}</p>
              </li>)}
          </ul>
        </div>

        {/* Right Column */}
        <div data-id="element-190">
          <h3 className="text-2xl font-serif text-ink mb-8 pb-4 border-b border-ink/20 opacity-70" data-id="element-191">
            No es para vos si...
          </h3>
          <ul className="space-y-6" data-id="element-192">
            {notForWho.map((item, i) => <li key={i} className="flex items-start gap-4 opacity-70" data-id="element-193">
                <div className="mt-1 text-ink/40 flex-shrink-0" data-id="element-194">
                  <X size={20} strokeWidth={2.5} data-id="element-195" />
                </div>
                <p className="font-sans text-ink/80 leading-relaxed" data-id="element-196">{item}</p>
              </li>)}
          </ul>
        </div>
      </div>
    </AnimatedSection>;
};